var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarDotsBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.4 8.30005H4V9.70005H5.4V8.30005Z",
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70005 8.30005H6.30005V9.70005H7.70005V8.30005Z",
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6001 8.30005H10.0001V9.70005H8.6001V8.30005Z",
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0H3.4V2H6.30005V0H7.70005V2H10.6001V0H12.0001V2H13C13.0557 2 13.1103 2.00455 13.1636 2.01331C13.2077 2.00458 13.2534 2 13.3001 2C13.6867 2 14.0001 2.3134 14.0001 2.7V13.3C14.0001 13.6866 13.6867 14 13.3001 14L13.2941 14H0.705954L0.7 14C0.313401 14 0 13.6866 0 13.3V2.7C0 2.3134 0.313401 2 0.7 2C0.746709 2 0.792349 2.00457 0.836497 2.0133C0.889701 2.00455 0.944319 2 1 2H2V0ZM12.6001 6H1.4V12.6H12.6001V6Z",
    fill: "#2F80ED"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDotsBlue);
export default __webpack_public_path__ + "static/media/calendar-dots_blue.600859b3.svg";
export { ForwardRef as ReactComponent };